import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { $supportEmail } from '../../../store/config/config.selectors';

@Component({
    selector: 'myrtls-auth-error',
    templateUrl: './error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, AsyncPipe],
})
export class AuthErrorComponent {
    error?: string;

    readonly supportEmail$ = this.store.pipe(select($supportEmail));

    constructor(
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private router: Router,
        private readonly store: Store<AppState>,
    ) {
        this.activatedRoute.queryParams.subscribe(params => {
            this.error = params['error'];
        });
    }

    continue() {
        console.log('Navigating to homepage...');
        this.router.navigateByUrl('/');
    }

    logout() {
        this.authService.logout({ logoutParams: { federated: true } });
    }
}
